import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import NewsListItem from "../models/item.interface";
import NewsListState from "../models/state.interface";
import fetchContentByType from "app/umbraco/helpers/fetchContentByType";
import moment from "moment";

export default (tags?: string[]): any => {
    const history = useHistory();
    const location = useLocation<NewsListState>();

    const initialItems = location.state?.posts;
    const [items, setItems] = useState<NewsListItem[]>(initialItems);

    const [viewState, setViewState] = useState<string>(initialItems?.length > 0 ? "LOADED" : "LOADING");

    useEffect(() => {
        let isComponentMounted = true;

        const fetchNews = async () => {
            let result: NewsListItem[] = [];
            const response = await fetchContentByType<NewsListItem[]>("newsPage", history.location.pathname);

            if (response && response.length > 0) {
                // Filter by tag
                const eligibleNews = response.filter(x => {
                    if (tags && tags.length > 0) {
                        const itemHasMatchTag = tags.some(tag => x.tags && x.tags.includes(tag));
                        return itemHasMatchTag;
                    }
                });

                // Sort by date desc
                const sortedNews = eligibleNews.sort((a: NewsListItem, b: NewsListItem) => {
                    const aDate = moment(a.date, "YYYY-MM-DDTHH:mm:ss");
                    const bDate = moment(b.date, "YYYY-MM-DDTHH:mm:ss");
                    return bDate.diff(aDate);
                });

                result = sortedNews;
            }

            if (isComponentMounted) {
                setItems(result);

                history.replace({
                    pathname: location.pathname,
                    search: location.search,
                    hash: location.hash,
                    state: {
                        ...location.state,
                        posts: result
                    }
                });

                return result;
            }
        };

        fetchNews().then((result: any) => {
            if (result && result.length > 0) {
                setViewState("LOADED");
            }
            else {
                setViewState("EMPTY");
            }
        }).catch(() => {
            setViewState("ERROR");
        });

        return () => {
            isComponentMounted = false;
        };
    }, [tags]);

    return { items, viewState };
};